import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21f5f26f&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=21f5f26f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5f26f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f5f26f')) {
      api.createRecord('21f5f26f', component.options)
    } else {
      api.reload('21f5f26f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=21f5f26f&scoped=true&lang=pug", function () {
      api.rerender('21f5f26f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/thankYou/download/index.vue"
export default component.exports